import { Accelerometer, GLView } from 'expo';
import React from 'react';
import { Dimensions, Platform, StyleSheet, Text, View, Button, Image } from 'react-native';

import DoodleJump from './Game/DoodleJump';
import KeyboardControlsView from './KeyboardControlsView';
import DisableBodyScrollingView from './DisableBodyScrollingView';
const Sensor = Accelerometer;
class App extends React.Component {
  state = { score: 0, prevScore : 0, mobile : false, status : "init", controls: true, size: Dimensions.get('window') };

  componentDidMount() {
    this.checkMobile();
    this.subscribe();
    Dimensions.addEventListener('change', this.onResize);
  }

  onResize = ({ window }) => {
    if (this.game) {
      this.game.resize(window);
    }
    this.setState({ size: window });
  };

  componentWillUnmount() {
    Dimensions.removeEventListener('change', this.onResize);
    this.unsubscribe();
    if (this.game) {
      this.game.deallocate();
    }
  }

  subscribe = async () => {
    if (!(await Sensor.isAvailableAsync())) {
      this.setState({ controls: false });
      return;
    }
    const isAndroid = Platform.OS === 'android';
    const isiOS = Platform.OS === "ios";
    // Accelerometer.setUpdateInterval(16);
    const isWeb = Platform.OS === 'web';
    Sensor.addListener(({ x }) => {
      let inputX = isiOS ? x * 0.3 : x;
      if (this.game) {
        if (isAndroid) {
          this.game.updateControls(inputX * -1);
        } else {
          this.game.updateControls(inputX);
        }
      }
    });
  };

  checkMobile = () => {
    let mobileAndTabletCheck = function() {
      let check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor);
      return check;
    };
    this.setState({mobile : mobileAndTabletCheck()});
  }

  unsubscribe = () => {
    Sensor.removeAllListeners();
  };

  onContextCreate = context =>
    (this.game = new DoodleJump(context, score => this.setState({ score }), (status, prevScore) => this.setState({ status, prevScore })));
  
  requestPermission = () => {
    DeviceMotionEvent.requestPermission().then(response => {
      if (response == 'granted') {
          this.setState({status : "init"})
          this.setState({controls : true})
          this.subscribe();
      }
    });
  }

  render() {
    const { size, controls, status, mobile } = this.state;

    // if(!mobile) {
    //   return (
    //     <View
    //       style={{
    //         flex: 1,
    //         justifyContent: 'center',
    //         alignItems: 'center',
    //       }}
    //     >
    //       <Image source={require('./assets/images/jo.png')} style={styles.jo}/>
    //       <Text style={{ fontSize: 40, fontWeight : "bold",  color: 'black', marginBottom : 10 }}>
    //         This game is designed for mobile.
    //         Please use mobile device.
    //       </Text>
    //       <Button title="Allow" color="#3b9933" onPress={() => {this.setState}} />
    //     </View>
    //   );
    // }

    if (!controls) {
      return (
        <View
          style={{
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Image source={require('./assets/images/jo.png')} style={styles.jo}/>
          <Text style={{ fontSize: 25, color: 'black',fontWeight : "bold", marginBottom : 20, textAlign : 'center' }}>
            Device Sensors are not available.
          </Text>
          <Text style={{ fontSize: 25, color: 'black', fontWeight : "bold", marginBottom : 20, textAlign : 'center' }}>
            Please click the allow button.
          </Text>
          <Button title="Allow" color="#3b9933" onPress={this.requestPermission} />
        </View>
      );
    }

    if (status === "init") {
      return (
        <View
          style={{
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Image source={require('./assets/images/jo.png')} style={styles.jo}/>
          <Text style={{ fontSize: 60, fontWeight : "bold",  color: 'black', marginBottom : 10 }}>
            Jo can fly
          </Text>
          <Text style={{ fontSize: 30, color: 'black', marginBottom : 20, textAlign : 'center' }}>
            Get The Highest Score!!
          </Text>
          <Text style={{ fontSize: 15, color: 'gray', marginBottom : 5, textAlign : 'center' }}>
            (This game is optimized for mobile.)
          </Text>
          <Text style={{ fontSize: 15, color: 'gray', marginBottom : 20, textAlign : 'center' }}>
            (Please tilt your phone to move Jo.)
          </Text>
          <Button title="Start" color="#3b9933" onPress={() => {this.setState({status : "running"})}} />
          
        </View>
      );
    }

    return (
      <>
        <View
          style={{
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            display : status === "died" ? "flex" : "none"
          }}
        >
          <Image source={require('./assets/images/jo.png')} style={styles.jo}/>
          <Text style={{ fontSize: 40, color: 'black', marginBottom : 10 }}>
            Your score
          </Text>
          <Text style={{ fontSize: 60, fontWeight : "bold", color: 'black',marginBottom : 10 }}>
            {this.state.prevScore}
          </Text>
          <Button title="Restart" color="#3b9933" onPress={() => {this.setState({status : "running"}); this.game.reset()}} />
        </View>
        <View
          style={[styles.container, { width: size.width, height: size.height, display : status === "died" ? "none" : "flex" }]}
        >
          <DisableBodyScrollingView>
            <KeyboardControlsView
              onKeyDown={({ code }) => {
                if (this.game) {
                  if (code === 'ArrowRight' || code === 'KeyD') {
                    this.game.onRight();
                  } else if (code === 'ArrowLeft' || code === 'KeyA') {
                    this.game.onLeft();
                  }
                }
              }}
              onKeyUp={() => this.game && this.game.onKeyUp()}
            >
              <GLView
                style={styles.container}
                onContextCreate={this.onContextCreate}
              />
              <Text style={styles.score}>{this.state.score}</Text>
            </KeyboardControlsView>
          </DisableBodyScrollingView>
        </View>
      </>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    maxWidth: '100%',
    maxHeight: '100%',
    overflow: 'hidden',
  },
  score: {
    position: 'absolute',
    top: 24,
    left: 12,
    fontSize: 36,
    opacity: 0.7,
    fontWeight: 'bold',
    color: 'black',
  },
  jo: {
    width: 80,
    height: 80,
    resizeMode: 'contain',
    marginBottom: 10
  },
});

export default App;
